import Api from '@/vuex/api'
import {
  NEW_CLIENT,
  ADD_CONTRACTOR,
  DELETE_COMPANY,
  EDIT_COMPANY,
  LOAD_COMPANY,
  OPEN_MODAL
} from '@/vuex/types'

const api = new Api()
const state = {
  company: {
    uuid: '',
    Accounts: [],
    accountsTotal: 0,
    accountsColumns: [],
    Contractors: [],
    contractorsTotal: 0,
    contractorsColumns: []
  },
  companyActions: [
    { label: 'Edit Company', command: EDIT_COMPANY, icon: 'fa fa-edit' },
    { label: 'Delete Company', command: DELETE_COMPANY, icon: 'fa fa-trash' }
  ]
}

const mutations = {
  [LOAD_COMPANY] (state, company) {
    state.company = { ...state.company, ...company }
  }
}

const getters = {
  companyActions ({ companyActions }) {
    return companyActions
  },
  loadedCompany ({ company }) {
    return company
  },
  companyManagers ({ company }) {
    return company.Accounts
  },
  companyManagersTotal ({ company }) {
    return company.accountsTotal
  },
  companyManagersColumns ({ company }) {
    return company.accountsColumns
  },
  companyContractors ({ company }) {
    return company.Contractors
  },
  companyContractorsTotal ({ company }) {
    return company.contractorsTotal
  },
  companyContractorsColumns ({ company }) {
    return company.contractorsColumns
  }
}

const actions = {
  async [LOAD_COMPANY] (context, companyUuid) {
    let company = await api.getCompany(companyUuid)
    context.commit(LOAD_COMPANY, company)
  },
  async [ADD_CONTRACTOR] (context, company) {
    let addContractorModal = {
      permalink: 'addContractor',
      options: {
        title: 'New Contractor',
        actionLabel: 'Save'
      },
      params: {
        companyUuid: company.uuid
      }
    }
    context.dispatch(OPEN_MODAL, addContractorModal)
  },
  async [NEW_CLIENT] (context, company) {
    let newClientModal = {
      permalink: 'newClient',
      options: {
        title: 'New Client',
        actionLabel: 'Save'
      },
      params: {
        companyUuid: company.uuid
      }
    }
    context.dispatch(OPEN_MODAL, newClientModal)
  },
  async [DELETE_COMPANY] (context, company) {
    let deleteCompanyModal = {
      permalink: 'deleteCompany',
      options: {
        title: 'Delete Company',
        actionLabel: 'Delete'
      },
      params: {
        companyUuid: company.uuid
      }
    }
    context.dispatch(OPEN_MODAL, deleteCompanyModal)
  },
  async [EDIT_COMPANY] (context, company) {
    let editCompanyModal = {
      permalink: 'editCompany',
      options: {
        title: 'Edit Company',
        actionLabel: 'Save'
      },
      params: {
        uuid: company.uuid
      }
    }
    context.dispatch(OPEN_MODAL, editCompanyModal)
  }
}

export default {
  state,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/vuex/modules/company.js